import { useAppSelector } from '../../store';

export const useCampaign = () => {
  const { currentCampaign: campaign } = useAppSelector((state) => state.campaigns);

  return {
    campaign,
  };
};
